import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Phone, PhoneOff, Lock, Crown } from "lucide-react";

export default function VoiceCallModal({ open, onClose, character, locked, onUpgrade }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-ink border-white/10 rounded-3xl max-w-sm p-0 overflow-hidden" data-testid="voice-call-modal">
        <DialogTitle className="sr-only">Voice call with {character?.name}</DialogTitle>
        <DialogDescription className="sr-only">Premium voice calling experience.</DialogDescription>
        <div className="relative p-8 text-center">
          <div className="relative w-28 h-28 mx-auto rounded-full overflow-hidden border-2 border-brand/50 mb-5 brand-glow">
            <img src={character?.active_outfit_url || character?.avatar_url} alt="" className="w-full h-full object-cover" />
          </div>
          <h2 className="font-heading text-2xl font-bold">{character?.name}</h2>
          <p className="text-muted-foreground text-sm mt-1">Voice calling…</p>

          {/* frequency waves */}
          <div className="flex items-end justify-center gap-1.5 h-16 mt-7">
            {Array.from({ length: 24 }).map((_, i) => (
              <span key={i} className="w-1 rounded-full bg-brand animate-wave"
                style={{ height: `${20 + (i % 5) * 14}px`, animationDelay: `${i * 60}ms` }} />
            ))}
          </div>

          {locked && (
            <div className="group absolute inset-0 z-20 glass flex flex-col items-center justify-center p-8 text-center overflow-hidden">
              <div className="absolute inset-0 -z-10 opacity-15 group-hover:opacity-45 plasma group-hover:plasma-fast transition-opacity duration-300" />
              <div className="w-14 h-14 rounded-2xl bg-brand flex items-center justify-center mb-4 brand-glow">
                <Lock className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-heading text-xl font-bold">Voice Call Locked</h3>
              <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
                Upgrade to Premium for live voice streaming, natural inflections, and auditory emotional support from your companion.
              </p>
              <Button data-testid="voice-upgrade-button" onClick={onUpgrade}
                className="mt-5 h-12 px-6 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold transition-colors">
                <Crown className="w-4 h-4 mr-2" /> Unlock Voice
              </Button>
            </div>
          )}

          <div className="flex items-center justify-center gap-4 mt-8">
            <button data-testid="voice-end-button" onClick={onClose}
              className="w-14 h-14 rounded-full bg-destructive flex items-center justify-center hover:opacity-90 transition-opacity">
              <PhoneOff className="w-6 h-6 text-white" />
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
